import { ref } from 'vue';

export function useMenu() {
  const isSubMenuOpen = ref(false);
  const menuReference = ref(null);

  const toggleSubMenu = () => {
    isSubMenuOpen.value = !isSubMenuOpen.value;
  };

  return {
    menuRef: menuReference,
    isSubMenuOpen,
    toggleSubMenu,
  };
}
